import { useState } from "react";
import Header from "../../../component/menu/Header";
import CustomLoader from "../../../component/menu/CustomLoader";
import { SettingOutlined, } from "@ant-design/icons";
import CouponAddOrEdit from "../../../component/coupon/CouponAddOrEdit";
import { Button, ConfigProvider } from "antd";
import { useNavigate } from "react-router-dom";

export default function CouponAdd() {
  const [editingCoupon, setEditingCoupon] = useState(null);
  const [isRelaunch, setIsRelaunch] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <CustomLoader />
      <Header title={"Coupon Settings"} /> {/* Assuming you keep existing header */}

      <div className="flex flex-col p-[24px] w-full mt-[80px] font-uregular">
        <div className="w-[80%] m-auto bg-white shadow-lg rounded-lg overflow-hidden">

          {/* Header Section */}
          <div className="p-5 border-b flex justify-between items-center">
            <div className="font-bold text-lg flex items-center">
              Create New Coupon
            </div>

            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#FCBD10",
                },
              }}
            >
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "#FCBD10",
                    colorPrimaryHover: "#FCBD10",
                    colorPrimaryActive: "#FCBD10",
                    colorTextLightSolid: "#000000",
                  },
                }}
              >
                <Button className="text-black font-semibold h-[48px] mr-1" type="primary" onClick={() => navigate('/coupon-settings')}>
                  List
                </Button>
              </ConfigProvider>
            </ConfigProvider>

          </div>

          {/* Body Section */}
          <div className="p-5">
            <CouponAddOrEdit />
          </div>

        </div>
      </div>
    </div>
  );
}